import SpecialOptions from '../classes/SpecialOptions';

export default function init(): void
{
	
	console.log('SpecialOptions');
	new SpecialOptions( );
}